module.exports = __webpack_public_path__ + "static/media/dashboardInventory_en.0bff2915.png";